import React from "react";
import { FaWhatsapp, FaEnvelope, FaGithub, FaLinkedin, FaTwitter } from "react-icons/fa";
import "./ContactPage.css";  // Importing styles

const ContactPage = () => {
  return (
    <div className="contact-container">
      <h1>Contact Me</h1>
      
      <div className="contact-item">
        <FaWhatsapp className="contact-icon" />
        <a href="https://wa.me/+966575685025" target="_blank" rel="noopener noreferrer">
          Chat on WhatsApp
        </a>
      </div>

      <div className="contact-item">
        <FaEnvelope className="contact-icon" />
        <a href="mailto:ammarmaroof447@gmail.com">ammarmaroof447@gmail.com</a>
      </div>

      <div className="social-links">
        

      </div>
    </div>
  );
};

export default ContactPage;
